import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProjectConstants } from '../project-constants';

@Component({
  selector: 'app-close-grievance-dialog',
  templateUrl: './close-grievance-dialog.component.html',
  styleUrls: ['./close-grievance-dialog.component.scss'],
})
export class CloseGrievanceDialogComponent implements OnInit {
  isFirst: boolean = false
  isReopen: boolean = false
  isDelete: boolean = false
  isObjDelete: boolean = false
  content: any;
  warningMsg = ProjectConstants.warningMsg
  closeGrievancetitle = ProjectConstants.closeGrievanceMsg
  okMsg = ProjectConstants.okMsg
  noMsg = ProjectConstants.noMsg
  yesMsg = ProjectConstants.yesMsg
  reopenGrievanceTitle = ProjectConstants.reopenGrievanceMsg
  deleteTitle = ProjectConstants.doYouwantToDelete
  deleteObjSuggetionTitle = ProjectConstants.doYouwantToDeleteObjectionSugestion
  constructor(public router: Router,
    public dialogRef: MatDialogRef<CloseGrievanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.content = this.data.content;
    if (this.data.id == "Close") {
      this.isFirst = true
    } else if (this.data.id == "delete") {
      this.isDelete = true
      this.isFirst = false
    }
    else if (this.data.id == "Reopen") {
      this.isFirst = false
      this.isDelete = false
      this.isReopen = true
    } else if (this.data.id == "isObjDelete") {
      this.isObjDelete = true
    }
  }
  onNoClick() {
    // this.dialogRef.close();
    this.dialogRef.close('No');
  }
  OkClick() {
    this.dialogRef.close('Yes');
  }
  onDeleteNoClick() {
    this.dialogRef.close('No');
  }

  onDeleteOkClick() {
    this.dialogRef.close('Yes');
  }
}
